import { render, staticRenderFns } from "./ExerciseListEdit.vue?vue&type=template&id=12d2c260"
import script from "./ExerciseListEdit.vue?vue&type=script&lang=js"
export * from "./ExerciseListEdit.vue?vue&type=script&lang=js"
import style0 from "./ExerciseListEdit.vue?vue&type=style&index=0&id=12d2c260&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports